import defaultFetch from 'isomorphic-unfetch'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string | undefined
  }
  fetch: typeof defaultFetch
  contextItemId: string
}

interface XsrfTokenResponse {
  token: string
}

export function createXsrfTokenClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    contextItemId = '',
  } = dependencies as Dependencies

  async function getToken(): Promise<string> {
    const params = new URLSearchParams({ contextitemid: contextItemId })
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/auth/xsrftoken?${params}`, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })

    if (!response.ok)
      throw new Error('Failed to fetch XSRF token')

    const responseBody = await response.json() as XsrfTokenResponse

    if (!responseBody.token)
      throw new Error('XSRF token is missing in the response')

    return responseBody.token
  }

  return { getToken }
}
